import { reportError } from "@utils/observability/reportError";

const IPCOPILOT_DOCUMENT_ID = "IPCOPILOT_DOCUMENT_ID";

export const insertText = async (text: string, html: string): Promise<void> => {
  return Word.run(async (context) => {
    const range = context.document.getSelection();
    if (html) {
      range.insertHtml(html, "Replace");
    } else {
      range.insertText(text, "Replace");
    }
    await context.sync();
  }).catch((error) => {
    reportError("word.insertText", error);
  });
};

export const getAllDocumentText = async (): Promise<string> => {
  return Word.run(async (context) => {
    const sections = context.document.sections;
    let doc_text = "";
    sections.load("items/body");
    await context.sync();
    for (let i = 0; i < sections.items.length; i++) {
      const doc_text_obj = sections.items[i].body.getHtml();
      const doc_text_header = sections.items[i].getHeader(Word.HeaderFooterType.primary);
      const doc_text_header_html = doc_text_header.getHtml();
      doc_text_header.load("text");
      const doc_text_footer = sections.items[i].getFooter(Word.HeaderFooterType.primary);
      const doc_text_footer_html = doc_text_footer.getHtml();
      doc_text_footer.load("text");
      // eslint-disable-next-line office-addins/no-context-sync-in-loop
      await context.sync();
      if (doc_text_header.text) {
        doc_text += doc_text_header_html.value;
      }
      doc_text += doc_text_obj.value;
      if (doc_text_footer.text && !doc_text_footer.text.match(/Page [0-9]+ of [0-9]+/)) {
        doc_text += doc_text_footer_html.value;
      }
    }
    return doc_text;
  });
};

export const setDocumentId = async (): Promise<string> => {
  return Word.run(async (context) => {
    const id = crypto.randomUUID();
    const props = context.document.properties.customProperties;
    props.add(IPCOPILOT_DOCUMENT_ID, id);
    await context.sync();
    return id;
  });
};

export const getDocumentId = async (): Promise<string> => {
  return Word.run(async (context) => {
    const props = context.document.properties.customProperties;
    props.load("items");
    await context.sync();
    const existing = props.items.find((i) => i.key === IPCOPILOT_DOCUMENT_ID);
    if (!existing) return setDocumentId();
    return existing.value as string;
  });
};
